import { defineMessages } from 'react-intl';

const messages = defineMessages({
  preview: {
    description: 'Preview Modal title',
    defaultMessage: 'Preview',
    id: 'wxwA/U',
  },
  desktop: {
    description: 'desktop preview link',
    defaultMessage: 'Desktop',
    id: 'YdJFBq',
  },
  tablet: {
    description: 'tablet preview link',
    defaultMessage: 'Tablet',
    id: 'tiMDws',
  },
  mobile: {
    description: 'mobile preview link',
    defaultMessage: 'Mobile',
    id: '39Ngfh',
  },
});

export default messages;
